import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex space-x-2" }
const _hoisted_2 = ["disabled", "title"]
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 absolute -top-0.5 -right-0.5 bg-red-600 rounded-full p-0.5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"])),
          class: "p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors",
          title: "Izmeni oglas"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (!_ctx.isActive)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.canRenew ? _ctx.$emit('renew') : null), ["stop"])),
          disabled: !_ctx.canRenew,
          class: _normalizeClass([
        'p-1.5 text-white rounded transition-colors relative',
        _ctx.canRenew
          ? 'bg-green-600 hover:bg-green-700 cursor-pointer'
          : 'bg-gray-600 cursor-not-allowed opacity-50',
      ]),
          title: 
        _ctx.canRenew
          ? 'Obnovi oglas'
          : 'Ne možete obnoviti oglas - dostigli ste maksimalan broj aktivnih oglasa'
      
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
              "clip-rule": "evenodd"
            })
          ], -1)),
          (!_ctx.canRenew)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[4] || (_cache[4] = [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('delete')), ["stop"])),
      class: "p-1.5 bg-red-600 hover:bg-red-700 text-white rounded transition-colors",
      title: "Obriši oglas"
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-4 w-4",
        viewBox: "0 0 20 20",
        fill: "currentColor"
      }, [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
          "clip-rule": "evenodd"
        })
      ], -1)
    ]))
  ]))
}